import React from "react";
import { FiExternalLink } from "react-icons/fi";
import Image from "../../../assets/D3ForLeft.svg";
const D3For = () => {
  return (
    <section className="pt-0 pb-20 md:py-20">
      <div className="container">
        <div className="grid md:grid-cols-2 gap-4 items-center">
          <div className="order-2 md:order-1">
            <h1 className="text-[30px] mb-4 md:text-[44px]">
              Who is <span className="text-primary font-semibold mb-4">D3</span>{" "}
              for?
            </h1>
            <p className="text-gray text-lg  max-w-xl">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Varius
              ultrices feugiat lectus donec etiam ultrices nunc. Adipiscing
              interdum mauris, facilisis leo netus elit lorem. Lorem in amet
              eleifend malesuada feugiat urna.{" "}
            </p>
            <button
              className=" bg-transparent border-2 border-dark-400  py-2.5 px-5 text-white  font-normal rounded-lg text-sm
            grid grid-flow-col items-center gap-2 uppercase mt-6
          "
            >
              <span>Learn more </span>
              <span className="text-xl text-primary">
                <FiExternalLink />
              </span>{" "}
            </button>
          </div>
          <div className="order-1 md:order-2">
            <img src={Image} alt="" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default D3For;
